import {
    BillLineItemColumn,
    BillLineItemView,
} from "@common/types/views/billViews";
import { NamedView, ViewType } from "@common/types/views/views";

export const ACCRUAL_REVIEW_BILL_LINE_ITEMS_VIEW_ID = "accrual-review";

export const createAccrualReviewBillLineItemsView = ({
    start,
    end,
}: {
    start: Date;
    end: Date;
}): NamedView<BillLineItemView> => ({
    id: ACCRUAL_REVIEW_BILL_LINE_ITEMS_VIEW_ID,
    name: "Accrual review",
    type: ViewType.BILL_LINE_ITEM,
    options: {
        selection: true,
        bulkActions: true,
    },
    columns: [
        { id: BillLineItemColumn.DATE, options: { pin: "left" } },
        { id: BillLineItemColumn.VENDOR },
        { id: BillLineItemColumn.DESCRIPTION },
        { id: BillLineItemColumn.AMOUNT },
        { id: BillLineItemColumn.ACCRUAL_ACCOUNT },
        { id: BillLineItemColumn.SCHEDULE },
        { id: BillLineItemColumn.MATCH },
        { id: BillLineItemColumn.DUE_DATE },
        { id: BillLineItemColumn.ACCOUNT },
        { id: BillLineItemColumn.ENTITY, options: { pin: "right" } },
    ],
    filters: {
        start,
        end,
    },
});
